import React from 'react';
import {BrowserRouter as Router, Route, Switch } from 'react-router-dom'


import Home from './components/Home';
import ContactForm from './components/contact-us';
import Solutions from './components/tally-prime-solutions';
import Features from './components/tally-prime-features';
import Faq from './components/tally-prime-faq';




function App() {
  return (
    <Router>
    <div className="App">
      
</div>
    <Switch>
      <Route exact path="/tallyprime/" component={Home} />
       <Route  path="/tallyprime/contact-us" component={ContactForm} />
       <Route  path="/tallyprime/tally-prime-solutions" component={Solutions} />
       <Route  path="/tallyprime/tally-prime-features" component={Features} />
       <Route  path="/tallyprime/tally-prime-faq" component={Faq} />
 
 </Switch>

    </Router>


  );
}



export default App;
